import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { SITE } from "../lib/site";

export default function CTABand({ title, subtitle, secondary }) {
  return (
    <section className="bg-[#7A2E39] text-white" data-testid="cta-band">
      <div className="container-x py-14 lg:py-20 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-8">
        <div>
          <h3 className="font-serif text-3xl lg:text-4xl mb-2">
            {title || "Une suspicion de termites ? Agissez sans attendre."}
          </h3>
          <p className="text-white/85 max-w-xl">
            {subtitle ||
              "Expertise visuelle gratuit en Bordeaux Métropole. Devis transparent sous 24 h."}
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3">
          <a
            href={`tel:${SITE.phoneRaw}`}
            className="bg-white text-[#7A2E39] hover:bg-[#E8DCC9] inline-flex items-center justify-center gap-2 px-6 py-3 rounded-sm text-sm font-bold tracking-wide transition-colors"
            data-testid="cta-band-call"
          >
            <Phone className="w-4 h-4" /> {SITE.phone}
          </a>
          {secondary !== false && (
            <Link
              to="/contact"
              className="border border-white/40 hover:bg-white/10 inline-flex items-center justify-center gap-2 px-6 py-3 rounded-sm text-sm font-bold tracking-wide transition-colors"
              data-testid="cta-band-expertise"
            >
              Demander une expertise <ArrowRight className="w-4 h-4" />
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
